<form class="create-customer-form" [formGroup]="cf" (keydown.enter)="enterClicked.emit($event)">
  <div class="company-form-fields-container">
    <app-form-input controlKey="name" labelT="customer-spaces.create-customer-form.company" />
    <app-form-input controlKey="erpAddressNumber" labelT="customer-spaces.create-customer-form.erp-address-number" />
    <app-form-input controlKey="erpProjectNumber1" labelT="customer-spaces.create-customer-form.erp-project-number" />
    <app-form-input controlKey="erpProjectNumber2" [labelT]="erpProjectNumber2Label()" />
    <app-form-select controlKey="abacusInstanceId" [items]="(abacusInstances$ | async)!"
      labelT="customer-spaces.create-customer-form.abacus-instance" />
    <app-form-input controlKey="abacusMandatorId" labelT="customer-spaces.create-customer-form.abacus-mandator" />

    <app-form-input *ngIf="cf.get('erpProjectNumber2')!.value !== '' || cf.get('erpProjectNumber3')!.value !== ''"
      controlKey="erpProjectNumber3" [labelT]="erpProjectNumber3Label()" />
    <app-form-input *ngIf="cf.get('erpProjectNumber3')!.value !== '' || cf.get('erpProjectNumber4')!.value !== ''"
      controlKey="erpProjectNumber4" [labelT]="erpProjectNumber4Label()" />

  </div>

  <div class="form-row">
    <div *ngIf="!!customerSpaceId" class="button-toggle-container">
      <span class="mat-caption">{{ 'customer-spaces.create-customer-form.status' | translate }}</span>
      <mat-button-toggle-group formControlName="status" class="status-toggle">
        <mat-button-toggle [value]="'Active'">
          {{ 'customer-spaces.status.active' | translate }}
        </mat-button-toggle>
        <mat-button-toggle [value]="'Inactive'">
          {{ 'customer-spaces.status.inactive' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="deactivation-comment">
      <mat-form-field class="comment-input" color="accent" *ngIf="isInactiveSelected()">
        <mat-label>{{ 'customer-spaces.create-customer-form.deactivation-comment' | translate }}</mat-label>
        <textarea matInput formControlName="deactivationComment" rows="3"></textarea>
        <mat-error *ngIf="cf.get('deactivationComment')!.hasError('deactivationCommentRequired')">
          {{ 'customer-spaces.create-customer-form.error.deactivation-comment-mandatory' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="deactivated-by" *ngIf="isInactiveSelected()">{{ deactivatedBy }} {{ deactivationTime | date:
        'dd.MM.yyyy HH:mm' }}</div>
    </div>
  </div>
</form>